<template>
  <Carousel v-bind="settings" v-model="modelValue" class="static">
    <Slide v-for="(slide, index) in slides" :key="index">
      <slot :item="slide" :index="index"></slot>
    </Slide>

    <template #addons="{ slidesCount, currentSlide }">
      <Pagination
        v-if="slidesCount > slidesForPagination && paginationActive"
      />
      <div
        v-if="
          navigationActive &&
          isNavigationArrowsTogether &&
          slidesCount > slidesForNavigation
        "
        :class="[
          'carousel__navigation carousel__navigation-static',
          paginationClass,
        ]"
      >
        <CarouselPagination
          v-if="showSlidesIndex && useDefaultSlideIndexing"
          :classes="slideIndexingClasses"
          :slide-index="currentSlide + 1"
          :total-slides="slidesCount"
        />

        <span
          v-else-if="showSlidesIndex && !useDefaultSlideIndexing"
          class="carousel_pagination-count desktop-body-l"
          >{{ currentSlide + 1 }} of {{ slidesCount }}</span
        >
        <Navigation>
          <template v-if="previousIconHtml" #prev>
            <div v-html="previousIconHtml"></div>
          </template>
          <template v-if="nextIconHtml" #next>
            <div v-html="nextIconHtml"></div>
          </template>
        </Navigation>
      </div>
      <Navigation
        v-else-if="slidesCount > slidesForNavigation && navigationActive"
      >
        <template v-if="previousIconHtml" #prev>
          <div v-html="previousIconHtml"></div>
        </template>
        <template v-if="nextIconHtml" #next>
          <div v-html="nextIconHtml"></div>
        </template>
      </Navigation>
    </template>
  </Carousel>
</template>

<script lang="ts" setup>
import { ICarouselConfig } from '../../types/carousel';
import { ref, toRefs, watch } from 'vue';
import { Carousel, Pagination, Slide, Navigation } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import CarouselPagination from '.././pagination/CarouselPagination.vue';

const props = withDefaults(
  defineProps<{
    slides: Array<any>;
    settings: ICarouselConfig;
    previousIconHtml?: string;
    nextIconHtml?: string;
    paginationActive?: boolean;
    slidesForPagination?: number;
    navigationActive?: boolean;
    slidesForNavigation?: number;
    isNavigationArrowsTogether?: boolean;
    selectedSlide?: number;
    showSlidesIndex?: boolean;
    paginationClass?: string;
    delayInTransition?: number;
    useDefaultSlideIndexing?: boolean;
    slideIndexingClasses?: string;
  }>(),
  {
    previousIconHtml: '',
    nextIconHtml: '',
    paginationActive: false,
    slidesForPagination: 1,
    navigationActive: false,
    slidesForNavigation: 1,
    isNavigationArrowsTogether: false,
    selectedSlide: 0,
    showSlidesIndex: false,
    paginationClass: '',
    delayInTransition: 0,
    useDefaultSlideIndexing: true,
    slideIndexingClasses: 'carousel_pagination-count subtitle-l',
  }
);
const {
  slides,
  settings,
  previousIconHtml,
  nextIconHtml,
  paginationActive,
  slidesForPagination,
  navigationActive,
  slidesForNavigation,
  selectedSlide,
  delayInTransition,
  useDefaultSlideIndexing,
  slideIndexingClasses,
} = toRefs(props);

const modelValue = ref(0);
const emit = defineEmits(['update:currentSlide']);
watch(modelValue, (value) => {
  if (value !== selectedSlide.value) {
    emit('update:currentSlide', value);
  }
});
watch(selectedSlide, (value) => {
  if (value !== modelValue.value) {
    if (delayInTransition.value === 0) modelValue.value = selectedSlide.value;
    else {
      setTimeout(() => {
        modelValue.value = selectedSlide.value;
      }, delayInTransition.value);
    }
  }
});
</script>
